export default __webpack_public_path__ + "static/media/design-illustration-2.6da6a00b.svg";